var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { outlined: "", elevation: "1" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", dense: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("New Completion Report")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "white",
                    text: "",
                    small: "",
                    to: "/completion-reports"
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-arrow-left")
                  ]),
                  _vm._v(" Back ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "formRef" },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              type: "date",
                              label: "Date",
                              "error-messages": _vm.errors.date
                            },
                            model: {
                              value: _vm.inputs.date,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "date", $$v)
                              },
                              expression: "inputs.date"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              label: "Customer",
                              items: _vm.customers,
                              "item-value": "id",
                              "item-text": item => `${item.id} - ${item.name}`,
                              "error-messages": _vm.errors.customer_id
                            },
                            model: {
                              value: _vm.inputs.customer_id,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "customer_id", $$v)
                              },
                              expression: "inputs.customer_id"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              label: "Project Name",
                              "error-messages": _vm.errors.project_name
                            },
                            model: {
                              value: _vm.inputs.project_name,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "project_name", $$v)
                              },
                              expression: "inputs.project_name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              label: "Description",
                              rows: "3",
                              "error-messages": _vm.errors.description
                            },
                            model: {
                              value: _vm.inputs.description,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "description", $$v)
                              },
                              expression: "inputs.description"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-subtitle-2 font-weight-bold mb-1"
                            },
                            [_vm._v("Scope of Works")]
                          ),
                          _vm._l(_vm.inputs.scope_of_works, function(item, i) {
                            return _c(
                              "v-row",
                              {
                                key: "scope-" + i,
                                attrs: { align: "center", dense: "" }
                              },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "11" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                        label: "Scope #" + (i + 1)
                                      },
                                      model: {
                                        value: _vm.inputs.scope_of_works[i],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.inputs.scope_of_works,
                                            i,
                                            $$v
                                          )
                                        },
                                        expression: "inputs.scope_of_works[i]"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "1" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "red"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeScope(i)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-close")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                small: "",
                                color: "blue darken-1",
                                dark: ""
                              },
                              on: { click: _vm.addScope }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-plus")
                              ]),
                              _vm._v(" Add Scope ")
                            ],
                            1
                          ),
                          _vm.errors.scope_of_works
                            ? _c(
                                "div",
                                { staticClass: "red--text text-caption" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.errors.scope_of_works[0]) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-subtitle-2 font-weight-bold mb-1"
                            },
                            [_vm._v("Work Completed")]
                          ),
                          _vm._l(_vm.inputs.work_completed, function(item, i) {
                            return _c(
                              "v-row",
                              {
                                key: "work-" + i,
                                attrs: { align: "center", dense: "" }
                              },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "11" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                        label: "Completed #" + (i + 1)
                                      },
                                      model: {
                                        value: _vm.inputs.work_completed[i],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.inputs.work_completed,
                                            i,
                                            $$v
                                          )
                                        },
                                        expression: "inputs.work_completed[i]"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "1" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "red"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeWork(i)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-close")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                small: "",
                                color: "blue darken-1",
                                dark: ""
                              },
                              on: { click: _vm.addWork }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-plus")
                              ]),
                              _vm._v(" Add Work ")
                            ],
                            1
                          ),
                          _vm.errors.work_completed
                            ? _c(
                                "div",
                                { staticClass: "red--text text-caption" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.errors.work_completed[0]) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              label: "Conclusion",
                              rows: "3",
                              "error-messages": _vm.errors.conclusion
                            },
                            model: {
                              value: _vm.inputs.conclusion,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "conclusion", $$v)
                              },
                              expression: "inputs.conclusion"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-subtitle-2 font-weight-bold mb-2"
                            },
                            [_vm._v("Images")]
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-caption grey--text text--darken-1 mb-2"
                            },
                            [
                              _vm._v(
                                " Up to " +
                                  _vm._s(_vm.maxImageMb) +
                                  " MB per image, " +
                                  _vm._s(_vm.maxTotalMb) +
                                  " MB in total. "
                              )
                            ]
                          ),
                          _vm.uploadError
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mb-3",
                                  attrs: { type: "error", dense: "", text: "" }
                                },
                                [_vm._v(" " + _vm._s(_vm.uploadError) + " ")]
                              )
                            : _vm._e(),
                          _vm._l(_vm.imageRows, function(row, rowIndex) {
                            return _c(
                              "v-row",
                              {
                                key: "row-" + rowIndex,
                                attrs: { dense: "", align: "center" }
                              },
                              _vm._l(row, function(img, i) {
                                return _c(
                                  "v-col",
                                  {
                                    key: "img-" + rowIndex + "-" + i,
                                    attrs: {
                                      sm: Math.floor(
                                        _vm.spanToNumber(img.span) * 12
                                      ),
                                      cols: 12
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-column",
                                        staticStyle: { gap: "10px" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            label: "Image Name"
                                          },
                                          model: {
                                            value: img.name,
                                            callback: function($$v) {
                                              _vm.$set(img, "name", $$v)
                                            },
                                            expression: "img.name"
                                          }
                                        }),
                                        _c("v-file-input", {
                                          attrs: {
                                            dense: "",
                                            outlined: "",
                                            accept: "image/*",
                                            "prepend-inner-icon": "mdi-image",
                                            "append-icon": "",
                                            label: "Image",
                                            "hide-details": !_vm.imageError(
                                              img
                                            ),
                                            "error-messages": _vm.imageError(
                                              img
                                            ),
                                            hint: img.file
                                              ? _vm.formatBytes(img.file.size)
                                              : "",
                                            "persistent-hint": !!img.file
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.onFileChange(
                                                $event,
                                                img
                                              )
                                            }
                                          }
                                        }),
                                        _c("v-select", {
                                          attrs: {
                                            dense: "",
                                            outlined: "",
                                            "hide-details": "",
                                            label: "Span",
                                            items: _vm.spanOptions,
                                            "item-text": "label",
                                            "item-value": "value"
                                          },
                                          model: {
                                            value: img.span,
                                            callback: function($$v) {
                                              _vm.$set(img, "span", $$v)
                                            },
                                            expression: "img.span"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    img.preview
                                      ? _c("v-img", {
                                          staticClass: "mt-2",
                                          attrs: {
                                            src: img.preview,
                                            "max-height": "200",
                                            contain: ""
                                          }
                                        })
                                      : _vm._e(),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "red"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeImage(img)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-close")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                small: "",
                                color: "blue darken-1",
                                dark: ""
                              },
                              on: { click: _vm.addImage }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-plus")
                              ]),
                              _vm._v(" Add Image ")
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                color: "primary",
                                dark: !_vm.saving,
                                disabled: _vm.saving,
                                loading: _vm.saving
                              },
                              on: { click: _vm.createReport }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-content-save")
                              ]),
                              _vm._v(" Save ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                color: "blue darken-2",
                                dark: "",
                                to: "/completion-reports"
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-list-box")
                              ]),
                              _vm._v(" Reports ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }